<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
					<div class="modal-title">
						{{ modalTitle }}
					</div>
					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>
				<div class="modal-body">
					{{ modalBody }}
				</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "NotificationModal",
    props: {
		modalTitle: {
			type: String,
			default: 'Title',
			Required: true
		},
		modalBody: {
			type: String,
			default: 'Body',
			Required: true
		}
    },
    emits: "closeModal",
    methods: {
        closeModal: function() {
            this.$emit('closeModal');
        },
    },
}
</script>

<style scoped>

</style>
